function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function Badge({
  as: Component = "span",
  tone = "neutral",
  className = "",
  children,
  ...props
}) {
  return (
    <Component
      {...props}
      className={joinClassNames(
        "lz-v2-badge",
        `lz-v2-badge--${tone}`,
        className
      )}
    >
      {children}
    </Component>
  );
}

export function StatusPill({ className = "", ...props }) {
  return (
    <Badge
      {...props}
      className={joinClassNames("lz-v2-status-pill", className)}
    />
  );
}
